import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2vcuhla4nw: FaireBrandEntity = {
  token: "b_2vcuhla4nw",
  type: "brand",
  name: "Tiana Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/2f07f7d2eacb8e07d81e9adf79f2881da88ef7057ee09260460447c950335430.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/43711e802f95f92cf782ca925f92f8bb4693cbd6f0118345390504ed64aa5dc8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2f07f7d2eacb8e07d81e9adf79f2881da88ef7057ee09260460447c950335430.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/43711e802f95f92cf782ca925f92f8bb4693cbd6f0118345390504ed64aa5dc8.jpeg",
  location: "Closter, NJ, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 399,
  isTopShop: true,
  isInsider: true,
  description:
    "TIANA is a USA based fashion house that creates one of a kind, handcrafted purses for the discerning woman. At the heart of every TIANA bag is the essence of the exquisitely crafted beads that it is made of. While TIANA is a product of the 21st century, its roots are firmly anchored in the traditions of hand craftsmanship in India, where each bag is distinct with a different story to tell. Only the choicest beads are sourced, cut and colored with utmost care to prepare them optimally for TIANA purses.\n\nEvery TIANA bag is handmade by master craftsmen using techniques that have been perfected over time. Beads, crystals and pearls are handled with care and precision to shape them into the unique form that marks each TIANA purse. Our purses are created in a meticulous way with the sole aim to incorporate refinement in every detail and never with a goal of efficiency. A lot of effort is put in to ensure that the bags keep their elegant form for a long time and age gracefully.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:48.175Z",
    importedBy: "entity-db-cli",
  },
};
